import React, { useEffect, useState } from "react";
import '../css/animate.css';
import '../css/barvy.css';
import '../css/style.css';
import { AnimatePresence, motion } from "framer-motion";
import { NavLink } from "react-router-dom";
import builder from "../utils/builderWithLocale";
import { getLocalizedText } from '../utils/textLocalization';

function App() {
  const [data, setData] = useState({});
  const [galerie, setGalerie] = useState([]);

  const [activeGallery, setActiveGallery] = useState(1);

  // Get localized text
  const configureText = getLocalizedText('configurator.configure');
  const openText = getLocalizedText('configurator.open');
  const customerConfigsText = getLocalizedText('configurator.customer_configs');

  useEffect(() => {
    document.title = getLocalizedText('configurator.page_title');
    builder.get("konfigurator").then(res => {
      setData(res.data);
      setGalerie(res.data.galerie);
      console.log(res.data.galerie)
    }).catch(err => {
      console.log(err)
    })
  }, [])

  const gradienty = [
    "linear-gradient(160deg, rgba(255, 62, 62, 0.4) 0%, rgba(143, 174, 118, 0) 65%, rgba(237, 221, 83, 0) 100%)",
    "linear-gradient(160deg, rgba(0, 255, 255, 0.4) 0%, rgba(0, 255, 128, 0) 65%, rgba(255, 255, 0, 0) 100%)",
    "linear-gradient(160deg, rgba(255, 231, 96, 0.4) 0%, rgba(255, 255, 255, 0) 65%, rgba(0, 0, 0, 0) 100%)",
    "linear-gradient(160deg, rgba(78, 255, 62, 0.4) 0%, rgba(143, 174, 118, 0) 65%, rgba(237, 221, 83, 0) 100%)",
    "linear-gradient(160deg, rgba(0, 102, 255, 0.4) 0%, rgba(0, 255, 128, 0) 65%, rgba(255, 255, 0, 0) 100%)",
    "linear-gradient(160deg, rgba(183, 96, 255, 0.4) 0%, rgba(255, 255, 255, 0) 65%, rgba(0, 0, 0, 0) 100%)",
    "linear-gradient(160deg, rgba(255, 117, 62, 0.4) 0%, rgba(143, 174, 118, 0) 65%, rgba(237, 221, 83, 0) 100%)",
    "linear-gradient(160deg, rgba(255, 0, 191, 0.4) 0%, rgba(0, 255, 128, 0) 65%, rgba(255, 255, 0, 0) 100%)",
    "linear-gradient(160deg, rgba(106, 96, 255, 0.4) 0%, rgba(255, 255, 255, 0) 65%, rgba(0, 0, 0, 0) 100%)",
    "linear-gradient(160deg, rgba(255, 62, 62, 0.4) 0%, rgba(143, 174, 118, 0) 65%, rgba(237, 221, 83, 0) 100%)",
    "linear-gradient(160deg, rgba(0, 255, 255, 0.4) 0%, rgba(0, 255, 128, 0) 65%, rgba(255, 255, 0, 0) 100%)",
    "linear-gradient(160deg, rgba(255, 231, 96, 0.4) 0%, rgba(255, 255, 255, 0) 65%, rgba(0, 0, 0, 0) 100%)",
    "linear-gradient(160deg, rgba(78, 255, 62, 0.4) 0%, rgba(143, 174, 118, 0) 65%, rgba(237, 221, 83, 0) 100%)",
    "linear-gradient(160deg, rgba(0, 102, 255, 0.4) 0%, rgba(0, 255, 128, 0) 65%, rgba(255, 255, 0, 0) 100%)",
    "linear-gradient(160deg, rgba(183, 96, 255, 0.4) 0%, rgba(255, 255, 255, 0) 65%, rgba(0, 0, 0, 0) 100%)",
    "linear-gradient(160deg, rgba(255, 117, 62, 0.4) 0%, rgba(143, 174, 118, 0) 65%, rgba(237, 221, 83, 0) 100%)",
    "linear-gradient(160deg, rgba(255, 0, 191, 0.4) 0%, rgba(0, 255, 128, 0) 65%, rgba(255, 255, 0, 0) 100%)",
    "linear-gradient(160deg, rgba(106, 96, 255, 0.4) 0%, rgba(255, 255, 255, 0) 65%, rgba(0, 0, 0, 0) 100%)",
    "linear-gradient(160deg, rgba(255, 62, 62, 0.4) 0%, rgba(143, 174, 118, 0) 65%, rgba(237, 221, 83, 0) 100%)",
    "linear-gradient(160deg, rgba(0, 255, 255, 0.4) 0%, rgba(0, 255, 128, 0) 65%, rgba(255, 255, 0, 0) 100%)",
    "linear-gradient(160deg, rgba(255, 231, 96, 0.4) 0%, rgba(255, 255, 255, 0) 65%, rgba(0, 0, 0, 0) 100%)",
    "linear-gradient(160deg, rgba(78, 255, 62, 0.4) 0%, rgba(143, 174, 118, 0) 65%, rgba(237, 221, 83, 0) 100%)",
    "linear-gradient(160deg, rgba(0, 102, 255, 0.4) 0%, rgba(0, 255, 128, 0) 65%, rgba(255, 255, 0, 0) 100%)",
    "linear-gradient(160deg, rgba(183, 96, 255, 0.4) 0%, rgba(255, 255, 255, 0) 65%, rgba(0, 0, 0, 0) 100%)",
    "linear-gradient(160deg, rgba(255, 117, 62, 0.4) 0%, rgba(143, 174, 118, 0) 65%, rgba(237, 221, 83, 0) 100%)",
    "linear-gradient(160deg, rgba(255, 0, 191, 0.4) 0%, rgba(0, 255, 128, 0) 65%, rgba(255, 255, 0, 0) 100%)",
    "linear-gradient(160deg, rgba(106, 96, 255, 0.4) 0%, rgba(255, 255, 255, 0) 65%, rgba(0, 0, 0, 0) 100%)",
  ];

  return (
    <AnimatePresence mode="wait">
      <motion.div className="configurator-background" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.3 }}>
      <div className="configurator-background-gradient"/>
      <div className="image-blocker-configurator"><img src="https://www.ridley-bikes.com/img/configurator-swirl.webp" className="configurator-background-image" alt="Configurator background"/></div>
      <motion.div className="page configurator" key="loading" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.3 }}>
        <h5>{data.nazev}</h5>
        <p className="configurator-text">{data.popis}</p>
        <NavLink to="https://www.ridley-bikes.com/en_US/configurator"><button className="configurator-undertext-button"><span>{configureText}</span></button></NavLink>
        <motion.div className="configurator-phases" key="loading" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.3 }}>

            {/* 
            <NavLink to={"https://www.ridley-bikes.com/en_CZ/configurator"}>
            <div className="config-banner" style={{marginTop: "50px"}}>
              <img src="https://www.ridley-bikes.com/img/configurator-swirl.webp"/>
              <h1 style={{color: "white"}}>Nakonfigurujte si vlastní kolo</h1>
              <button><span>Konfigurovat</span></button>
            </div>
            </NavLink>
            */}

            <h2 className="configurator-ridley">{customerConfigsText}</h2>

            <div className="conf-list-bikes-rework">
              {data.kola && (
                <>
                  {data.kola.map((element, index) => (
                    <NavLink key={index} to={element.redirect}>
                      <div>
                        <img src={element.obrazek+"?format=webp"} style={{background: gradienty[index % gradienty.length],}} alt={element.nazev || "Bike"}/>
                        <h3>{element.nazev}</h3>
                        <p>{element.popis}</p>
                        <h4><span>{openText}</span></h4>
                      </div>
                    </NavLink>
                  ))}
                </>
              )}
            </div>
        </motion.div>

        <motion.div className="configurator-galerie" key="loading" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.3 }}>
            <div className="conf-gallery">
            {galerie && (galerie.map((element, key) => (
              <div className={activeGallery === key+1 && "conf-gallery-active"} onClick={() => {setActiveGallery(key+1)}}>
                <img src={element.obrazek + "?format=webp"} alt={`Gallery ${key+1}`}/>
              </div>
            )))}
            </div>
            <div className="conf-gallery-arrows">
              {galerie && galerie.map((element, key) => (
                <>
                  <button onClick={() => {setActiveGallery(key+1)}} className={activeGallery === key+1 && "conf-gallery-arrows-active"} />
                </>
              ))}
            </div>
        </motion.div>

      </motion.div>
      </motion.div>
    </AnimatePresence>
  );
}

export default App;
